export default "__VITE_ASSET__1PPZopJAy9kH5xWN2$lQJg__"